// extracted by mini-css-extract-plugin
export default {"container":"Discover_container__Zm9rX"};